import React, { useState } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import axios from "axios";
import squaresImg from "../images/lesson/squares.svg";

const TABS = [
  // { id: 1, name: "Видео" },
  // { id: 2, name: "Тренажер" },
  { id: 3, name: "Теория" },
];

const LessonContent = ({
  lessonContent,
  prevLesson,
  nextLesson,
  siteUrl,
  themeUrl,
  seoContent,
  baseUrl,
}) => {
  const [activeTab, setActiveTab] = useState(3);
  const [isOpen, setOpen] = useState(false);
  const [value, setValue] = useState("");
  const [isSuccess, setSuccess] = useState(false);
  const [isError, setError] = useState(false);
  const handleTabClick = (id) => () => setActiveTab(id);

  const handleChange = ({ target }) => {
    const { value } = target;
    setValue(value);
  };

  const handleClose = () => {
    setOpen(false);
    setSuccess(false);
    setError(false);
  };

  const handleSubmit = (ev) => {
    ev.preventDefault();
    axios
      .post(`${siteUrl}backend/api/web/callback_errors`, {
        message: value,
        url: window.location.href,
      })
      .then(() => {
        setSuccess(true);
        setValue("");
      })
      .catch(() => {
        setError(true);
        setValue("");
      });
  };

  const renderLessonBanner = () => (
    <div className="lesson__banner ">
      <p className="lesson__banner-invite">
        Войдите или зарегистрируйтесь, чтобы учиться без ограничений
      </p>
      <p className="lesson__banner-details">
        Смотрите видео по теме урока и занимайтесь на интерактивном тренажере
      </p>
      <div className="lesson__banner-image" />
      <a href={`${baseUrl}auth`}>
        <button className="lesson__banner-link">Начать учиться</button>
      </a>
    </div>
  );

  const renderActions = () => (
    <div className="lesson__actions">
      {prevLesson.url ? (
        <a className="lesson__prev" href={prevLesson.url}>
          Урок {prevLesson.index}
        </a>
      ) : (
        <div className="empty" />
      )}
      <a className="lesson__to-theme" href={themeUrl}>
        <img src={squaresImg} alt="" />
        <span>Вернуться к теме</span>
      </a>
      {nextLesson.url ? (
        <a className="lesson__next" href={nextLesson.url}>
          Урок {nextLesson.index}
        </a>
      ) : (
        <div className="empty" />
      )}
    </div>
  );

  const renderCallbackForm = () => (
    <form className="modal-form" onSubmit={handleSubmit}>
      <div className="modal-close-btn" onClick={handleClose} />
      <h3>Заметили ошибку?</h3>
      <span>Расскажите нам об ошибке, и мы ее исправим.</span>
      <textarea value={value} onChange={handleChange} placeholder="Cообщение" />
      <button disabled={!value.trim()} className="purple-button" type="submit">
        Отправить
      </button>
    </form>
  );

  const renderModalContent = () => {
    return (
      <div className="modal-container">
        {!isSuccess && !isError ? (
          renderCallbackForm()
        ) : (
          <div className="modal-form">
            <span>
              {isSuccess
                ? "Спасибо за то, что помогаете сделать Учебник лучше!"
                : "Произошла ошибка, попробуйте позже."}
            </span>
            <button className="purple-button" onClick={handleClose}>
              Закрыть
            </button>
          </div>
        )}
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="lesson__pages-wr">
        <ul className="lesson__pages">
          {TABS.map((item) => (
            <li
              key={item.id}
              className={cn("lesson__pages-item", {
                "selected-page": activeTab === item.id,
              })}
              onClick={handleTabClick(item.id)}
            >
              {item.name}
            </li>
          ))}
        </ul>
        <span className="lesson__error" onClick={() => setOpen(true)}>
          Заметили ошибку?
        </span>
      </div>

      {activeTab === 3 ? (
        <div className="lesson__theory">
          <div
            className="lesson__theory-block"
            dangerouslySetInnerHTML={{ __html: lessonContent }}
          />
        </div>
      ) : (
        renderLessonBanner()
      )}
      {renderActions()}

      <div
        className={cn("modal", {
          active: isOpen,
        })}
      >
        {renderModalContent()}
      </div>
      <div className="lesson__seo">
        <div
          className="lesson__seo-content"
          dangerouslySetInnerHTML={{ __html: seoContent }}
        />
      </div>
    </React.Fragment>
  );
};

LessonContent.propTypes = {
  lessonContent: PropTypes.string,
  prevLesson: PropTypes.object,
  nextLesson: PropTypes.object,
  themeUrl: PropTypes.string,
  seoContent: PropTypes.string,
  baseUrl: PropTypes.string,
};

export default LessonContent;



// WEBPACK FOOTER //
// ./app/frontend/components/LessonContent.js